<template>
  <div class="container-lg">
    <div class="compare">
      <div v-if="isEmptyCompareProducts" class="table-wrapper">
        <table class="compare-table mt-5 mb-5">
          <thead>
          <tr>
            <td></td>
            <td v-for="(product, index) in comparisonData.products">
              <div class="product  product--compare">
                <div class="product__preview">
                  <picture>
                    <source :srcset="product.image.webp" type="image/webp">
                    <img class="product__image" :src="product.image.source" :alt="product.title">
                  </picture>
                  <button class="product__delete" type="button" :title="in18['page_remove_product_btn']"
                          @click="removeProductFromCompareList(product)">
                    <img src="/shop/images/compare-delete.svg" alt="">
                  </button>
                </div>
                <div class="text-center">
                  <h3 class="product__title">
                    <a :href="product.link" :title="product.title">{{ product.title }}</a>
                  </h3>
                  <product-price class="justify-center pb-4 pt-2" :prices="product.prices" class-name="product__price"/>
                  <add-to-cart-button :product-id="product.id" :title="in18['page_add_product_btn_title']"/>
                </div>
              </div>
            </td>
          </tr>
          </thead>
          <tbody>
          <template v-for="(group, groupName) in comparisonData.groups">
            <tr>
              <td class="compare-table__title" :colspan="comparisonData.products.length + 1">
                {{ groupName }}
              </td>
            </tr>
            <tr v-for="(attributes, attributeName) in group">
              <td>
                {{ attributeName }}
              </td>
              <td v-for="(product) in comparisonData.products" class="col">
                <span v-html="attributes[product.id]"></span>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
      </div><!-- /.table-wrapper -->

      <div v-else class="mt-5">
        <div class="section">
          <div class="text-center mb-5">
            <h1 class="section__title section__title--lg">
              {{ in18['system_compare_empty'] }}
            </h1>
            <div class="section__text">
              {{ in18['system_compare_empty_description'] }}
            </div>
            <div class="section__text mt-5">
              <a class="btn  btn--red  btn--sm" :href="home_link" :title="in18['page_return_home']">
                {{ in18['page_return_home'] }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div><!-- /.compare -->
  </div><!-- /.container -->
</template>
<script>

import axios from 'axios';
import AddToCartButton from "../components/product/AddToCartButton.vue";

export default {
  name:       'CompareProducts',
  components: {
    'add-to-cart-button': AddToCartButton,
  },
  data() {
    return {
      comparisonData: {},
    };
  },
  props:    [
    'in18',
    'home_link'
  ],
  computed: {
    comparedProducts: {
      get() {
        return this.$store.getters.comparedProducts
      },
      set(value) {
        this.$store.commit('REMOVE_COMPARED_PRODUCTS', value)
      },
    },
    isEmptyCompareProducts() {
      return this.comparisonData.products ? this.comparisonData.products.length : 0;
    },
  },
  created() {
    this.fetchProducts();
  },
  methods: {

    fetchProducts() {
      axios.post('/api/product-compare', {'product_compare': this.comparedProducts})
          .then((response) => {
            this.comparisonData = response.data;
          })
          .catch((error) => {
            window.toastr.error(error.response.data.message);
          });
    },

    removeProductFromCompareList(product) {
      this.comparedProducts = product.id;
      this.fetchProducts();
    },
  },
};
</script>
